'use client';

import React, { createContext, useCallback, useContext, useState } from 'react';

import { clsx } from 'clsx';

import cls from './Accordion.module.scss';

type AccordionProps = {
  children: React.ReactNode;
  className?: string;
  customIcon?: boolean;
};

export const Accordion: React.FC<AccordionProps> = ({ children, className }) => {
  const [isOpening, setIsOpening] = useState<boolean>(false);

  const onChangeStatus = useCallback(() => {
    setIsOpening(!isOpening);
  }, [isOpening]);

  const initValue = {
    isOpening: isOpening,
    setIsOpening: onChangeStatus
  };

  return (
    <AccordionContext.Provider value={initValue}>
      <div className={clsx(cls.wrap, className)}>{children}</div>
    </AccordionContext.Provider>
  );
};

type AccordionContextType = {
  isOpening: boolean;
  setIsOpening: () => void;
  customIcon?: boolean;
};

const AccordionContext = createContext<AccordionContextType | undefined>(undefined);

export const useAccordion = () => {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error('useAccordion must be used within an Accordion');
  }
  return context;
};
